import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { chain, map } from 'lodash';
var TabNewProvidersComponent = /** @class */ (function () {
    function TabNewProvidersComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.loadingProviders = false;
        this.duplicatedServiceProvider = null;
        this.linkProviderForm = this.formBuilder.group({
            segment: [null, [Validators.required]],
            maintenanceTypes: this.formBuilder.array([], [Validators.required])
        });
    }
    TabNewProvidersComponent.prototype.ngOnInit = function () {
        this.serviceProvidersFormArray.markAllAsTouched();
    };
    TabNewProvidersComponent.prototype.linkServiceProvider = function () {
        this.duplicatedServiceProvider = null;
        var linkProviderFormValue = this.linkProviderForm.getRawValue();
        linkProviderFormValue.maintenanceTypes = chain(linkProviderFormValue.maintenanceTypes)
            .filter(function (_a) {
            var value = _a.value;
            return !value.isAllOption;
        })
            .map('value')
            .value();
        this.validateServiceProviders(linkProviderFormValue);
        if (this.duplicatedServiceProvider) {
            this.linkProviderForm.setErrors({ duplicated: true });
            return;
        }
        var serviceProvidersControl = this.formBuilder.group({
            company: [null],
            deadlineContract: [null],
            maintenanceTypes: [linkProviderFormValue.maintenanceTypes],
            segment: [linkProviderFormValue.segment, [Validators.required]]
        });
        this.serviceProvidersFormArray.push(serviceProvidersControl);
        this.linkProviderForm.reset();
    };
    TabNewProvidersComponent.prototype.deleteServiceProvider = function (index) {
        var serviceProvider = this.serviceProvidersFormArray.at(index).value;
        var linkProviderForm = this.linkProviderForm.value;
        this.serviceProvidersFormArray.removeAt(index);
        var isSameSegment = linkProviderForm.segment && serviceProvider.segment.id === linkProviderForm.segment.id;
        if (isSameSegment && this.linkProviderForm.hasError('duplicated')) {
            this.linkProviderForm.setErrors({});
            this.linkProviderForm.updateValueAndValidity();
        }
    };
    TabNewProvidersComponent.prototype.mappedMaintenanceTypes = function (maintenanceTypes) {
        return chain(maintenanceTypes).map('name').sortBy().value().join(', ');
    };
    TabNewProvidersComponent.prototype.validateServiceProviders = function (_a) {
        var segmentToAdd = _a.segment, maintenanceTypes = _a.maintenanceTypes;
        var maintenanceTypesToAddId = map(maintenanceTypes, 'id');
        var existingServiceProviders = this.serviceProvidersFormArray.getRawValue();
        var existingServiceProvidersWithSameSegment = existingServiceProviders.filter(function (serviceProvider) {
            return serviceProvider.segment.id === segmentToAdd.id;
        });
        if (!existingServiceProvidersWithSameSegment.length) {
            return;
        }
        var existingServiceProviderForAllMaintenanceTypes = existingServiceProvidersWithSameSegment
            .filter(function (serviceProvider) { return !serviceProvider.maintenanceTypes.length; });
        if (existingServiceProviderForAllMaintenanceTypes.length) {
            this.duplicatedServiceProvider = {
                allMaintenanceTypesAlreadyExists: true
            };
            return;
        }
        var existingServiceProvidersMaintenanceTypes = chain(existingServiceProvidersWithSameSegment)
            .flatMap('maintenanceTypes')
            .sortBy('name')
            .value();
        if (!maintenanceTypesToAddId.length) {
            this.duplicatedServiceProvider = {
                maintenanceTypes: existingServiceProvidersMaintenanceTypes
            };
            return;
        }
        var duplicatedServiceProvidersMaintenanceTypes = existingServiceProvidersMaintenanceTypes
            .filter(function (_a) {
            var id = _a.id;
            return maintenanceTypesToAddId.includes(id);
        });
        if (duplicatedServiceProvidersMaintenanceTypes.length) {
            this.duplicatedServiceProvider = {
                maintenanceTypes: duplicatedServiceProvidersMaintenanceTypes
            };
        }
    };
    return TabNewProvidersComponent;
}());
export { TabNewProvidersComponent };
